export const CURRENT = 1
export const SAVINGS = 2
export const INVESTMENT = 3
export const CREDIT_CARD = 4